// extracted by mini-css-extract-plugin
export default {"addButton":"ActivitiesPage_addButton__2P7bo"};